import { render } from "./LanguageModal.vue?vue&type=template&id=ee603674&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"

import "./LanguageModal.vue?vue&type=style&index=0&id=ee603674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee603674"]])

export default __exports__